<div class="grid">
    <!-- <p-messages severity="info" class="col xl:col-6 lg:col-12 md:col-12 sm:col-12 xs:col-12">
        <ng-template pTemplate>
            <div class="col xl:col-12 lg:col-12 md:col-12 sm:col-12 xs:col-12">
                <div class="surface-card border-round shadow-2 p-1" style="height: 100%">
                    <div class="flex flex-row p-3">
                        <span class="text-xl text-left font-medium text-90">Employee Import Instructions</span>
                    </div>
                    <div class="p-3">
                        <ul>
                            <li>
                                The Employee Import synchronizes eFAACT with the employee and payroll details setup in GovConPay.
                            </li>
                            <ul>
                                <li>
                                    Step 1: In GovConPay, maintain all employee and payroll information.
                                </li>
                                <li>
                                    Step 2: Click Start Import which imports employee and payroll details from GovConPay.
                                </li>
                                <li>
                                    Step 3: After the INITIAL import and for NEW employees. Run an eFAACT Sync Lists to finalize the employee setup.
                                </li>
                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-messages> -->
    <div class="col xl:col-12 lg:col-12 md:col-12 sm:col-12 xs:col-12 mt-1">
        <div class="surface-card border-round shadow-2 p-1" style="height: 100%">
            <div class="flex flex-row p-3">
                <span class="text-xl text-left font-medium text-90">Initial GovConPay Import Steps</span>
            </div>
            <div class="p-1">
                <ul>
                    <p>
                        The import synchronizes eFAACT with the employee and payroll details setup in GovConPay.
                    </p>                   
                    <ul>
                        <li>
                            Step 1: In GovConPay, maintain all employee and payroll information.
                        </li>
                        <li>
                            Step 2: Click Start Import which imports employee and payroll details from GovConPay.
                        </li>
                        <li>
                            Step 3: After the INITIAL import and for NEW employees. Run an eFAACT Sync Lists to finalize the employee setup.
                        </li>
                    </ul>
                </ul>
            </div>
        </div>
    </div>
    <div class="col xl:col-12 lg:col-12 md:col-12 sm:col-12 xs:col-12 mt-1">
        <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
            <div class="text-left p-3 w-6">
                <span class="text-xl text-left font-medium text-90">Import</span>
                <p>The GovConPay import is required to bring in the initial employee information and payroll details during implementation. 
                    After the initial setup, the import is only necessary when new paycodes are added or existing paycodes are updated in GovConPay.
                    New or updated employee information is automatically synchronized from GovConPay to eFAACT and does not require running the import.
                </p>               
            </div>
            <div class="p-3">
                @for (message of messages; track message; let first = $first) {
                    <p-message [severity]="message.severity" [text]="message.summary" [ngClass]="{ 'mt-4': !first }" />
                }
                <!-- <p-messages [value]="messages" styleClass="popup-alert"></p-messages> -->
            </div>

            <div class="ml-3 mt-1 mb-1">
                <div class="flex items-center">
                    <p-checkbox
                        #includeInactiveCheckbox
                        [(ngModel)]="includeInactive"
                        (ngModelChange)="SetIncludeInactive.next(includeInactive)"
                        [binary]="true"
                    ></p-checkbox>
                    <label class="ml-2">Include Inactive</label>
                </div>               
            </div>
            <div class="p-3 flex justify-content-start">
                <button pButton class="p-button-primary" (click)="StartImport.next(includeInactive)">Start Import</button>
            </div>
        </div>
    </div>
</div>



<!-- <p-messages severity="info">
    <ng-template pTemplate>
        <ul>
            <li>In isolved, setup the new employee information.</li>
            <li>
                In eFAACT Central, click Employee Import to import the isolved
                information.
            </li>
            <ul>
                <li>
                    In eFAACT Desktop, run a Sync Lists which makes the employee
                    available.
                </li>
                <div style="padding-left: 3rem">-- OR --</div>
                <li>
                    In QBO run Sync Lists which makes the employee available.
                </li>
            </ul>
        </ul>
    </ng-template>
</p-messages> -->
<!-- <p
    style="
        display: flex;
        justify-items: flex-start;
        justify-content: space-around;
        width: 300px;
    "
>
    <button
        pButton
        (click)="StartImport.next(includeInactive)"
    >
        Start Import
    </button>
    <p-checkbox
        #includeInactiveCheckbox
        [(ngModel)]="includeInactive"
        (ngModelChange)="SetIncludeInactive.next(includeInactive)"
        [binary]="true"
        label="Include Inactive"
    ></p-checkbox>
</p> -->
<!-- <p-messages [value]="messages" styleClass="popup-alert"></p-messages> -->
